import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertTextOnImageWidgetToServerModel = (widget) => {
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.textOnImage,
        data: {
            ...widget.value.data,
        },
        properties: {
            displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
            overlayOpacity: widget.value.properties.overlayOpacity,
            overlayColor: widget.value.properties.overlayColor,
        },
    };
};
export const convertTextOnImageFromServerModel = (serverModel) => {
    var _a, _b;
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.textOnImage,
            data: {
                ...serverModel.data,
            },
            properties: {
                displayDelayInSeconds: serverModel.properties.displayDelayInSeconds,
                overlayOpacity: (_a = serverModel.properties.overlayOpacity) !== null && _a !== void 0 ? _a : 50,
                overlayColor: (_b = serverModel.properties.overlayColor) !== null && _b !== void 0 ? _b : '#000000',
            },
        },
    };
};
